import sentCyclesService from './sentCyclesService';

import type { SentCycle } from '@/types/cycle-evaluation/SentCycle';

import { CycleEvaluationQueryKey } from '@/constants/QueryKeys';
import { useAmelioPaginatedQuery } from '@/hooks/api/useAmelioPaginatedQuery';

const useGetSentCyclesPaged = ({
    cycleEvaluationId,
    pageNumber,
    pageSize,
}: {
    cycleEvaluationId: string;
    pageNumber: number;
    pageSize: number;
}) => {
    return useAmelioPaginatedQuery<SentCycle>({
        queryKey: [CycleEvaluationQueryKey.SENT_CYCLES, cycleEvaluationId],
        queryFn: sentCyclesService.getSentCycles,
        pageNumber,
        pageSize,
        meta: { cycleEvaluationId },
        options: {
            enabled: !!cycleEvaluationId,
        },
    });
};

export { useGetSentCyclesPaged };
